import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DebugService {
  private panelOpenSubject = new BehaviorSubject<boolean>(false);
  public panelOpen$ = this.panelOpenSubject.asObservable();

  constructor() {}

  /**
   * Check if debug mode is enabled (non-production environment)
   */
  isDebugMode(): boolean {
    return !environment.production;
  }

  /**
   * Toggle the debug panel visibility
   */
  togglePanel(): void {
    this.panelOpenSubject.next(!this.panelOpenSubject.value);
  }

  /**
   * Open the debug panel
   */
  openPanel(): void {
    this.panelOpenSubject.next(true);
  }

  /**
   * Close the debug panel
   */
  closePanel(): void {
    this.panelOpenSubject.next(false);
  }

  /**
   * Get current panel state
   */
  isPanelOpen(): boolean {
    return this.panelOpenSubject.value;
  }

  /**
   * Get sanitized environment information
   */
  getEnvironmentInfo(): { key: string; value: string }[] {
    const envInfo: { key: string; value: string }[] = [
      { key: 'Production', value: environment.production.toString() },
      { key: 'Environment Name', value: (environment as { name?: string }).name || 'production' },
      { key: 'Firebase Project ID', value: environment.firebase.projectId },
      { key: 'Firebase App ID', value: environment.firebase.appId },
      { key: 'Firebase Auth Domain', value: environment.firebase.authDomain },
      { key: 'Firebase Database URL', value: environment.firebase.databaseURL || 'N/A' },
      { key: 'Firebase Storage Bucket', value: environment.firebase.storageBucket },
      { key: 'Firebase Measurement ID', value: environment.firebase.measurementId || 'N/A' }
    ];

    return envInfo;
  }
}
